export default __webpack_public_path__ + "static/media/rashid_khreiss.c7f129b9.jpg";